// document.addEventListener("DOMContentLoaded", function () {
//   const itemsToShow = 9; // how many to show each time
//   const blogs = document.querySelectorAll(".blog-item");
//   const loadMoreBtn = document.getElementById("loadMoreBtn");

//   if (loadMoreBtn) {
//     loadMoreBtn.addEventListener("click", function () {
//       let hiddenItems = document.querySelectorAll(".blog-item.hidden");
//       for (let i = 0; i < itemsToShow && i < hiddenItems.length; i++) {
//         hiddenItems[i].classList.remove("hidden");
//       }
//       if (document.querySelectorAll(".blog-item.hidden").length === 0) {
//         loadMoreBtn.style.display = "none"; // Hide button when no more blogs
//       }
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  const itemsToShow = 6; // how many posts per click

  // Loop through all tabs (1 to 6)
  for (let i = 1; i <= 6; i++) {
    const loadMoreBtn = document.getElementById(`loadMoreBtn-${i}`);
    const tabPane = document.getElementById(`tab${i}`);

    if (loadMoreBtn && tabPane) {
      loadMoreBtn.addEventListener("click", function () {
        let hiddenItems = tabPane.querySelectorAll(".blog-item.hidden");
        
        for (let j = 0; j < itemsToShow && j < hiddenItems.length; j++) {
          hiddenItems[j].classList.remove("hidden");
        }

        if (tabPane.querySelectorAll(".blog-item.hidden").length === 0) {
          loadMoreBtn.style.display = "none"; // hide button if no more blogs
        }
      });
    }
  }
});


//  ============  product page slider =============

$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:'<i class="far fa-chevron-left prod_slider_prev"></i>',
  nextArrow:'<i class="far fa-chevron-right prod_slider_next"></i>',
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  // prevArrow:'<i class="far fa-chevron-left prod_slider_prev"></i>',
  // nextArrow:'<i class="far fa-chevron-right prod_slider_next"></i>',
  dots: false,
  focusOnSelect: true,
  verticalSwiping:true,

responsive: [
  {
    breakpoint: 992,
    settings: {
      slidesToShow: 5,
    }
  },
 
  {
    breakpoint: 576,
    settings: {
    slidesToShow: 3,
    }
  },
  {
    breakpoint: 380,
    settings: {
    slidesToShow: 3,
    }
  }
  ]
});





// testimonila slider
jQuery(document).ready(function($) {
  $(".gallery-slider").slick({
      infinite: true,
      adaptiveHeight: true,
      slidesToShow: 1,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>'
  });
  $(".testimonials-slider1").slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
      responsive: [
        {
          breakpoint: 2000,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 3.1
          }
        },
       
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1.5
          }
        },
          {
              breakpoint: 576,
              settings: {
                slidesToShow: 1
              }
            }
        ]
  });
  // Function to show/hide arrows based on the current slide
  function toggleArrows() {
      let $slider = $('.testimonials-slider');
      let currentSlide = $slider.slick('slickCurrentSlide');
      let totalSlides = $slider.slick('getSlick').slideCount;
      let slidesToShow = $slider.slick('getSlick').options.slidesToShow;

      // Hide 'prev' arrow if it's the first slide
      if (currentSlide === 0) {
          $slider.find('.slick-prev').hide();
      } else {
          $slider.find('.slick-prev').show();
      }

      // Hide 'next' arrow if it's the last slide
      if (currentSlide + slidesToShow >= totalSlides) {
          $slider.find('.slick-next').hide();
      } else {
          $slider.find('.slick-next').show();
      }
  }

  // Initial arrow toggle on page load
  toggleArrows();

  // Arrow toggle on slide change
  $('.testimonials-slider').on('afterChange', function () {
      toggleArrows();
  });
});



// blog slider
jQuery(document).ready(function($) {
  $(".news-article-sc").slick({
      infinite: false,
      slidesToShow: 3.9,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
      responsive: [
        {
          breakpoint: 2000,
          settings: {
            slidesToShow: 3.9,
          }
        },
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 3.9
          }
        },
       
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1.5
          }
        },
          {
              breakpoint: 576,
              settings: {
                slidesToShow: 1
              }
            }
        ]
  });
  // Function to show/hide arrows based on the current slide
  function toggleArrows() {
      let $slider = $('.news-article-sc');
      let currentSlide = $slider.slick('slickCurrentSlide');
      let totalSlides = $slider.slick('getSlick').slideCount;
      let slidesToShow = $slider.slick('getSlick').options.slidesToShow;

      // Hide 'prev' arrow if it's the first slide
      if (currentSlide === 0) {
          $slider.find('.slick-prev').hide();
      } else {
          $slider.find('.slick-prev').show();
      }

      // Hide 'next' arrow if it's the last slide
      if (currentSlide + slidesToShow >= totalSlides) {
          $slider.find('.slick-next').hide();
      } else {
          $slider.find('.slick-next').show();
      }
  }

  // Initial arrow toggle on page load
  toggleArrows();

  // Arrow toggle on slide change
  $('.news-article-sc').on('afterChange', function () {
      toggleArrows();
  });
});





// product page slider

jQuery(document).ready(function($) {
  $(".news-article-sc-1").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.5
          }
        },
          {
              breakpoint: 576,
              settings: {
                slidesToShow: 1.7
              }
            },
            {
              breakpoint:425,
              settings: {
                slidesToShow: 1
              }
            }
        ]
  });
  // Function to show/hide arrows based on the current slide
  function toggleArrows() {
      let $slider = $('.news-article-sc-1');
      let currentSlide = $slider.slick('slickCurrentSlide');
      let totalSlides = $slider.slick('getSlick').slideCount;
      let slidesToShow = $slider.slick('getSlick').options.slidesToShow;

      // Hide 'prev' arrow if it's the first slide
      if (currentSlide === 0) {
          $slider.find('.slick-prev').hide();
      } else {
          $slider.find('.slick-prev').show();
      }

      // Hide 'next' arrow if it's the last slide
      if (currentSlide + slidesToShow >= totalSlides) {
          $slider.find('.slick-next').hide();
      } else {
          $slider.find('.slick-next').show();
      }
  }

  // Initial arrow toggle on page load
  toggleArrows();

  // Arrow toggle on slide change
  $('.news-article-sc-1').on('afterChange', function () {
      toggleArrows();
  });
});